(ns practitest.frontend.dashboard-item-settings.subs
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.subs :as global-subs]))

(re-frame/reg-sub
 ::state
 (fn [db _]
   (get db :dashboard-item-settings)))

(re-frame/reg-sub
 ::field
 :<- [::state]
 (fn [state [_ k]]
   (get state k)))

(re-frame/reg-sub
 ::project-id
 (fn [db _]
   (global-subs/get-current-project-id db)))
